import React from "react";

function NavBar() {
  return (
    <nav class="navbar navbar-expand-lg navstyle">
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <i class="fa fa-bars" aria-hidden="true"></i>
      </button>

      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="nav navbar mr-auto">
          <li class="nav-item">
            <a class="nav-link" aria-current="page" href="#Profile">
              Home
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#Experience">
              Experience
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#Education">
              Education
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#Projects">
              Projects
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" href="#Contact">
              Contact
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default NavBar;
